import * as types from '../../action-types';
import {getSingleEducation as initialState } from "../../initialState";

const getSingleEducation = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_EDUCATION_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_EDUCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_EDUCATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_EDUCATION_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleEducation;
